import React, { useContext } from 'react';
import { Box, Button, Footer, ResponsiveContext, Text } from 'grommet';
import {  History } from 'grommet-icons';
const footer_margin  = {  margintop: 100, borderTop: "1px dashed #ccc" } ;

const FooterExample = (props) => {
  const user = props.user;
  const size = useContext(ResponsiveContext);
  const year = new Date().getFullYear();

  return (
    <Footer
      background="background-front"
      direction={!['xsmall', 'small'].includes(size) ? 'row' : 'column'}
      align={!['xsmall', 'small'].includes(size) ? 'center' : undefined}
      pad={{ horizontal: 'medium', vertical: 'small' }}
      fill="horizontal" style= {footer_margin}
    >
      <Box
        direction={!['xsmall', 'small'].includes(size) ? 'row' : 'column'}
        align={!['xsmall', 'small'].includes(size) ? 'center' : undefined}
        gap="xsmall"
      >
        <Text size="small">
          &copy; {year} Hewlett Packard Enterprise Development LP
        </Text>
      </Box>
      <Box
        direction="row"
        align={!['xsmall', 'small'].includes(size) ? 'center' : undefined}
        gap="xsmall"
        wrap
      >
       {user?.version_id &&  <span>
            Revision Version : <a href={user.version_link} key={user.version_id} target="_blank">{user.version_id}</a> <a href="https://hpe.sharepoint.com/teams/smartird/Release%20Notes/Forms/ByAuthor.aspx" target="_blank" title="Previous Revisions"><History style={{height:12}}/></a></span> }
      </Box>
    </Footer>
  );
};

export default FooterExample